const trust = {
  transparency: {
    hero: {
      eyebrow: "Transparency & Impact",
      title: "Every rupee tracked, every outcome reported",
      subtitle:
        "We treat donor trust as our most precious resource. Here is the proof.",
    },
    metrics: {
      donations: "Annual Donations Processed",
      families: "Donor Families",
      lives: "Lives Directly Supported",
      donorFunded: "Donor-Funded · No Grants",
    },
    utilization: {
      eyebrow: "Donation Utilization",
      title: "Where every donated rupee goes",
      subtitle:
        "Allocation for the financial year 2025-26 — verified by independent audit.",
      residentCare: "Resident Care & Bhojan",
      healthcare: "Healthcare & Medicines",
      gaushala: "Gaushala & Animal Care",
      gruhUdhyog: "Gruh Udhyog & Livelihood",
      operations: "Operations & Compliance",
    },
    highlights: {
      eyebrow: "Annual Highlights",
      title: "Milestones of recent years",
      y2026: {
        title: "Trust-wide digital platform",
        body: "Unified admin & donor experience, 80G receipts on demand, real-time impact dashboards.",
      },
      y2025: {
        title: "New medical wing inaugurated",
        body: "4-cabin clinic with physiotherapy and a daycare unit funded entirely by community donors.",
      },
      y2024: {
        title: "Tiffin Seva crosses 100K meals",
        body: "Daily warm meals delivered to elders living alone across Mumbai.",
      },
      y2023: {
        title: "Gaushala scaled to 40+ animals",
        body: "Expanded shelter, fodder storage and on-site veterinary cabin.",
      },
    },
    reports: {
      eyebrow: "Reports & Filings",
      title: "Open documents, freely available",
      subtitle:
        "For copies of any report below, please reach out via our contact page.",
      request: "Request",
      annual: {
        title: "Annual Report 2025-26",
        note: "Programs, finances, audited statements",
      },
      impact: {
        title: "Impact Report 2025",
        note: "Resident, healthcare & gaushala outcomes",
      },
      form10b: {
        title: "Form 10B (Audit)",
        note: "Filed with Income Tax Department",
      },
      certs: {
        title: "12A & 80G Certificates",
        note: "Tax-exemption recognition",
      },
    },
    achievements: {
      eyebrow: "Trust Achievements",
      title: "Recognitions & compliance",
      certified: {
        title: "12A & 80G Certified",
        body: "Income-tax exempt status. Donations qualify for 50% deduction under 80G.",
      },
      samman: {
        title: "Gujarat Seva Samman 2024",
        body: "Recognised by the State Trust Council for sustained eldercare service.",
      },
      audit: {
        title: "100% Audit Compliance",
        body: "Independently audited every year since inception. Reports available on request.",
      },
    },
    cta: {
      title: "Give with confidence",
      subtitle:
        "Every donation is acknowledged, receipted under 80G, and accounted for in our published reports.",
      donate: "Donate Now",
      talk: "Talk to Us",
    },
  },
  trustees: {
    hero: {
      eyebrow: "Leadership",
      title: "Our Trustees",
      subtitle: "The guardians of Jivandhara's vision and values.",
    },
    empty: "To be announced.",
  },
  committee: {
    hero: {
      eyebrow: "Our team",
      title: "Committee Members",
      subtitle: "The people steering our daily seva.",
    },
    empty: "To be announced.",
  },
};

export default trust;
